export default __webpack_public_path__ + "static/media/P12.7ca62049.png";